export default {
  stickyHeaderDesktop: '100px',
  stickyHeaderDesktopSmall: '80px',
  stickyHeaderMobile: '80px',
  stickyHeaderMobileSmall: '67.5px',
};
